import React from 'react';

import { CANVAS_LINE_HEIGHT, CANVAS_LONG_WIDTH, CANVAS_SHORT_WIDTH } from 'src/features/statistics/utils/constants';
import { canvasDisplaySpecifics } from 'src/features/statistics/utils/digitalReceipt';

interface DigitalReceiptCanvasProps {
    receiptTextLines?: string[];
}

const DigitalReceiptCanvas = React.forwardRef<React.ElementRef<'canvas'>, DigitalReceiptCanvasProps>(
    ({ receiptTextLines }, ref) => {
        const canvasRef = React.useRef<HTMLCanvasElement | null>(null);
        const [isLoadedFont, setIsLoadedFont] = React.useState(false);

        React.useEffect(() => {
            const ibmPlexMono = new FontFace(
                'IBM Plex Mono',
                'url(https://fonts.gstatic.com/s/ibmplexmono/v19/-F63fjptAgt5VM-kVkqdyU8n1isq131nj-otFQ.woff2)',
            );
            void ibmPlexMono.load().then(() => {
                document.fonts.add(ibmPlexMono);
                setIsLoadedFont(true);
            });
        }, []);

        React.useEffect(() => {
            if (!canvasRef.current || !receiptTextLines || !isLoadedFont) {
                return;
            }
            canvasDisplaySpecifics(canvasRef.current, receiptTextLines);
        }, [receiptTextLines, isLoadedFont]);

        if (!receiptTextLines) return null;

        const longestLine = receiptTextLines.reduce((acc, line) => (line.length > acc ? line.length : acc), 0);
        const canvasWidth = longestLine > 40 ? CANVAS_LONG_WIDTH : CANVAS_SHORT_WIDTH;

        return (
            <canvas
                ref={(node) => {
                    canvasRef.current = node;
                    if (typeof ref === 'function') {
                        ref(node);
                    } else if (ref) {
                        ref.current = node;
                    }
                }}
                width={canvasWidth}
                height={CANVAS_LINE_HEIGHT * receiptTextLines.length + CANVAS_LINE_HEIGHT}
                className="rounded-xl border p-2 shadow-sm"
            />
        );
    },
);
DigitalReceiptCanvas.displayName = 'DigitalReceiptCanvas';

export { DigitalReceiptCanvas };
